import React from 'react';
import { SubNavLink } from './NavBar.styles';
import { NavItemConfig } from './NavBar.types';

interface SubNavItemProps {
  child: NavItemConfig;
}

export const SubNavItem: React.FC<SubNavItemProps> = ({ child }) => {
  const childContent = (
    <li>
      <SubNavLink to={child.path} exact={child.exact} activeClassName="active">
        {child.title}
      </SubNavLink>
    </li>
  );

  if (child.allowedAuthorization) {
    return childContent;
  }

  return childContent;
};
